import { createSlice } from '@reduxjs/toolkit';

import { getAffiliateLinkFromId, sawPinExtensionModal, UserState } from './actions';

const initialState: UserState = {
  affiliateLink: null,
  seenPinExtensionModal: false
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sawPinExtensionModal, (state) => {
        state.seenPinExtensionModal = true;
      })
      .addCase(getAffiliateLinkFromId.fulfilled, (state, action) => {
        state.affiliateLink = action.payload.affiliate_link;
      })
      .addCase(getAffiliateLinkFromId.rejected, (state) => {
        state.affiliateLink = null;
      });
  }
});

export default userSlice.reducer;
